import {Component, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import {IToolCommandItemButton, MagicLinkModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';

@Component({
    standalone: false,
    selector: 'app-platform-tool-treaty-other-version-button',
  templateUrl: './platform-tool-treaty-other-version-button.component.html',
  styleUrls: ['./platform-tool-treaty-other-version-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlatformToolTreatyOtherVersionButtonComponent implements OnInit, IToolCommandItemButton {

  clicked: EventEmitter<any>;
  command: PlatformCommand;
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  constructor() { }

  ngOnInit(): void {
  }

  executeCommand (command: PlatformCommand) {
    this.clicked.emit(command);
  }

}
